import axiosInstance from '..';

export const uploadFile = async (formData: FormData) =>
  await axiosInstance.post(`/v1/Files/Upload`, formData);
